import Chartist from 'chartist'
// eslint-disable-next-line
import * as Gradient from 'chartist-plugin-gradient'
import { max, min } from 'lodash'
import React, { useEffect, useRef } from 'react'
import { Trans } from 'react-i18next'
import { CABINET_URL } from 'shared/constants'

import useTokenDetail from 'shared/hooks/useTokenDetail'

import { asNumber, asUSD } from 'shared/utils/money'

import Button from './Button'
import { TokenObjectForm } from './TokenCard'

const TokenDataExchange = ({ token = 'DCGT' }) => {
  const { tokenDetails, tokenRates } = useTokenDetail(token)

  const currentChart = useRef()
  const nextChart = useRef()

  const totalPercent = Number((tokenDetails.data.totalSold / tokenDetails.data.total) * 100).toFixed(1)
  const roundPercent = Number((tokenDetails.data.roundSold / tokenDetails.data.round) * 100).toFixed(1)

  function createTokenChart(currentRef, data, mylow = 0, myHigh = 0, myHeight = '11rem', valueString, myClass = '') {
    if (currentRef.current) {
      new Chartist.Line(currentRef.current, data, {
        high: myHigh,
        low: mylow,
        scaleMinSpace: 10,
        showArea: true,
        areaBase: parseFloat(mylow).toFixed(2),
        showPoint: true,
        axisX: {
          showGrid: false,
          offset: 0,
          showLabel: false,
        },
        axisY: {
          showGrid: false,
          offset: 0,
          showLabel: false,
        },
        height: myHeight,
        fullWidth: true,
        chartPadding: {
          right: 0,
          left: 0,
        },
        plugins: [
          Chartist.plugins.ctAreaGradient({
            threshold: parseFloat(mylow).toFixed(2),
          }),
        ],
      })
    }
  }

  useEffect(() => {
    const dataRates = tokenRates.data

    if (dataRates) {
      const data2 = {
        labels: dataRates.map((item) => item.date),
        series: [dataRates.map((item) => (item.amount > 0 ? item.amount : 0))],
      }

      const data1 = {
        labels: dataRates.filter((item, key) => key < dataRates.length - 1).map((item) => item.date),
        series: [
          dataRates
            .filter((item, key) => key < dataRates.length - 1)
            .map((item) => (item.amount > 0 ? item.amount : 0)),
        ],
      }

      const low1 = data1.series?.[0]?.[0] || 0
      const low2 = data2.series?.[0]?.[0] || 0

      const minAmount = min(data2.series?.[0])
      const maxAmount = max(data2.series?.[0])
      const diff = (maxAmount - minAmount) * 2

      const high1 = low1 + diff
      const high2 = maxAmount + diff

      createTokenChart(currentChart, data1, low1, high1, '11rem', ` ${token}`, 'green')
      createTokenChart(nextChart, data2, low2, high2, '11rem', ` ${token}`, 'green')
    }
  }, [JSON.stringify(tokenRates.data)])

  const handleBuyOnExchange = () => {
    window.location.href = `${CABINET_URL}/exchange?token=${token}`
  }

  return (
    <div className="object-col object-data">
      <div className="object-title">Токенсейл завершен</div>

      <div className="object--rates" style={{ border: 'none', paddingBottom: 0 }}>
        <div className="object-rates">
          <div className="object-rate">
            <div className="object-rate--title">
              <Trans i18nKey={'Текущий курс на бирже'} />
            </div>
            <div className="object-rate--content">
              <div className="object-rate--value">
                <div className="rate" style={{ width: '100%' }}>
                  <div className="rate--content">
                    <div className="rate--title">{token}/USDT</div>
                    <div className="rate--value">{asUSD(tokenDetails.data.rate)}</div>
                  </div>
                </div>
                <div className="object-rate--value-title" />
                <div className="object-rate--value-value" />
              </div>

              <div className="object-rate--chart">
                <div id="rate-chart1" className="rate-chart token-chart-sm token-chart-sm_green" ref={currentChart} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="object--progress" style={{ display: 'none' }}>
        <div className="object-progress">
          <div className="object-progress--header">
            <div className="object-progress--title">
              <Trans
                i18nKey={'Продано всего {{token}}'}
                components={{
                  token,
                }}
              />
            </div>
            <div className="object-progress--value">
              {asNumber(tokenDetails.data.totalSold)} {token}
            </div>
          </div>
          <div className="object-progress--bars">
            <div className="progress-bar">
              <div className="progress-bar--line">
                <div className="progress-line">
                  <div className="progress-line--value" style={{ width: `${totalPercent}%` }} />
                </div>
              </div>
              <div className="progress-bar--value">{`${asNumber(totalPercent, 1)}%`}</div>
            </div>
          </div>
        </div>
        <div className="object-progress">
          <div className="object-progress--header">
            <div className="object-progress--title">
              <Trans i18nKey={'Продано в текущем раунде*'} />
            </div>
            <div className="object-progress--value">
              {asNumber(tokenDetails.data.roundSold)} {token}
            </div>
          </div>
          <div className="object-progress--bars">
            <div className="progress-bar">
              <div className="progress-bar--line">
                <div className="progress-line">
                  <div className="progress-line--value" style={{ width: `${roundPercent}%` }} />
                </div>
              </div>
              <div className="progress-bar--value">{`${asNumber(roundPercent, 1)}%`}</div>
            </div>
          </div>
          <div className="object-progress--description">
            <Trans
              i18nKey={
                'Продажи разделены на раунды по {{amount}} {{token}}. На данный момент каждый пройденный раунд увеличивает курс токена на {{percent}}%.'
              }
              components={{
                amount: asNumber(100000),
                token,
                percent: 1,
              }}
            />
          </div>
        </div>
      </div>

      {/* <TokenObjectForm tokenDetails={tokenDetails.data} /> */}

      <Button variant={'primary'} onClick={handleBuyOnExchange}>
        <Trans i18nKey={'Купить на бирже'} />
      </Button>
    </div>
  )
}

export default TokenDataExchange
